import React from 'react';
import Css from './ContentItems.module.css';
import ProductItem from './ProductItem/ProductItem';
import SkeletonItems from './SkeletonItems/SkeletonItems';
import { memo } from 'react';


const ContentItems =  memo((props) => {


  return (

    <div className={Css.content}>
      <div className={Css.listAtems}>
        {props.isFetchingItems ? Array.from(new Array(39)).map((u, i) => {
          return (
            <div key={i} className={Css.userBlock} style={{ paddingLeft: "10px", marginTop: "29px", marginBottom: "40px" }}>
              <SkeletonItems />
            </div>
          )
        })
          : props.catologItems
            .map((u, i) => {
              return (
                <div key={i} className={Css.userBlock}>
                  <ProductItem price={u.CATALOG_PRICE_1} previewText={u.PREVIEW_TEXT} image={u.TIMTHUB} title={u.NAME} producer={u.PROPERTY_PRODUCER_VALUE} country={u.PROPERTY_COUNTRY_VALUE} idItem={u.ID} ppid={u.CATALOG_PRICE_ID_1} code={u.CODE} basketFish={props.basketitemsId.includes(u.ID, 0)} getCatalogItemsFish={props.getCatalogItemsFish} fakprice={u.PROPERTY_FAKEPRICE_VALUE} saleprice={u.CATALOG_PRICE_1_SALE} discont={u.PROPERTY_DISCOUNT_VALUE} images={u.TIMTHUB_IMAGES}/>
                </div>
              )

            }

            )

        }
      </div>
    </div>

  );
});

export default ContentItems;